import React, {useState, useEffect} from "react";
import { Box, Typography, Grid2, Button, CircularProgress } from '@mui/material';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from "../firebase/firebaseConfig";
import SeccionFotosMisDiseños from "../elements/pages/Main/SeccionFotosMisDiseños";

const MisDiseños = () => {
    const [misDiseños, setMisDiseños] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);
    
    // Función para truncar el texto
    const truncateText = (text, maxLength = 200) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    }

    useEffect(() => {
        onSnapshot(collection(db, 'inforesumenproductowebcalocho'),
            (snapshot) => {
                const arregloMisDiseños = snapshot.docs.map((docMisDiseños) => {
                    return {...docMisDiseños.data(), id: docMisDiseños.id};
                })

                setMisDiseños(arregloMisDiseños);
                setLoading(false); // Data has been loaded
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    // Carrusel: Actualizar el índice cada 10 segundos
    useEffect(() => {
        if (misDiseños.length > 1) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % misDiseños.length);
            }, 10000); // 10000ms = 10s
            return () => clearInterval(interval);
        }
    }, [misDiseños.length]);
    
    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress sx={{ color: '#5d0303' }} />
            </Box>
            );
        }

        if (misDiseños.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography variant="h6">No hay datos por mostrar</Typography>
            </Box>
        );
    }

    return(
        <Box
            sx={{
                backgroundColor: '#0a1f44',
                color: '#fff',
                backgroundImage: 'linear-gradient(180deg, #8E0505, #5d0303)',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                padding: { xs: '2%', sm: '4%', md: '5%' },
                gap: { xs: 2, sm: 4 },

            }}
        >
            <SeccionFotosMisDiseños />

            <Grid2 key={misDiseños[currentIndex].id}
                xs={12} sm={8} md={6}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: { xs: '90%', sm: '60%', md: '50%' },
                    height: 'auto',
                    padding: { xs: '5%', sm: '2%' },
                    margin: { xs: '5% auto', sm: '0 auto' },
                    alignItems: 'center',
                }}
            >
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 'bold',
                        fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                        margin: { xs: '12px 0', sm: '18px 0' },
                        textAlign: 'center',
                    }}
                >
                    {misDiseños[currentIndex].titulo}
                </Typography>
                <Typography
                    variant="h5"
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.2rem' },
                        margin: { xs: '10px 0', sm: '15px 0' },
                        textAlign: 'center',
                    }}
                >
                    {misDiseños[currentIndex].subtitulo}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                        margin: { xs: '8px 0', sm: '12px 0' },
                        textAlign: 'center',
                    }}
                >
                    <span>{truncateText(misDiseños[currentIndex].descripcion)}</span>
                </Typography>
                <Button
                    variant="outlined"
                    size="small"
                    sx={{
                        width: { xs: '80%', sm: '60%', md: '50%' },
                        alignSelf: 'center',
                        color: '#f9f9f9',
                        background: '#8E0505',
                        borderColor: '#f9f9f9',
                        mt: 2,
                        ':hover': {
                            backgroundColor: '#ff6f61',
                            borderColor: '#f9f9f9',
                        },
                    }}
                >
                    Ver más
                </Button>
            </Grid2>
        </Box>
    );
}

export default MisDiseños;
